import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import './RentBookPage.css';
import config from '../functions/config';



function RentBookPage() {
  const [book, setBook] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [rentDays, setRentDays] = useState(1); // Default rental period
  const [rentDate, setRentDate] = useState(new Date().toISOString().slice(0, 10)); // Today's date
  const [returnDate, setReturnDate] = useState('');
  const [userName, setUserName] = useState('');
  const [status, setStatus] = useState('Pending');
  const [fine, setFine] = useState(0.0); // Fine is always zero
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { bookId } = useParams(); // Get the book ID from the URL
  const navigate = useNavigate(); // For navigation (redirect after action)

  useEffect(() => {
    // Fetch book details
    axios.get(`${config.BASE_URL}/api/books/${bookId}/`)
      .then(response => {
        setBook(response.data);
        setLoading(false);
      })
      .catch(() => {
        setError('Error fetching book details');
        setLoading(false);
      });

    // Get user details from session
    const sessionId = Cookies.get('sessionid');
    if (sessionId) {
      getUserDetails(sessionId);
    }
  }, [bookId]);

  useEffect(() => {
    // Calculate return date based on rent date and days
    const rentDateObj = new Date(rentDate);
    const calculatedReturnDate = new Date(rentDateObj.setDate(rentDateObj.getDate() + parseInt(rentDays)));
    setReturnDate(calculatedReturnDate.toISOString().slice(0, 10));
  }, [rentDate, rentDays]);

  const getUserDetails = async (sessionId) => {
    try {
      const response = await fetch("http://127.0.0.1:8000/api/details/", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Session-ID": sessionId,
        },
        credentials: "include",
      });

      if (response.ok) {
        const userData = await response.json();
        setUserName(userData.username);
      } else {
        const errorData = await response.json();
        setError(errorData.error || "Error fetching user details.");
      }
    } catch {
      setError("Failed to fetch user details.");
    }
  };

  const handleRent = () => {
    if (quantity > book.stock) {
      alert('Quantity exceeds available stock');
      return;
    }

    // Calculate the per-day rental price (2% of the book's price)
    const dailyRentPrice = (book.price * 0.02);
    const totalPrice = dailyRentPrice * rentDays;

    // Prepare rental data
    const rentalData = {
      book: book.id,
      quantity,
      phone_number: phoneNumber,
      rent_date: rentDate,
      return_date: returnDate,
      fine: 0.0, // Fine is always zero
      status,
      total_price: totalPrice,
      user_name: Cookies.get('sessionid'),
    };

    // API call to rent the book
    axios.post(`${config.BASE_URL}/api/rent/`, rentalData)
      .then(() => {
        alert(`You rented "${book.title}"!`);
        navigate('/success'); // Redirect to rental history page
      })
      .catch(() => {
        alert('Error processing rental');
      });
  };

  const handleIncrement = () => {
    setRentDays(prev => prev + 1);  // Increase rental period by 1 day
  };

  const handleDecrement = () => {
    if (rentDays > 1) {
      setRentDays(prev => prev - 1); // Decrease rental period by 1 day
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!book) return <div>Book not found</div>;

  return (
<div>
  <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
    <div className="container-fluid">
      <a className="navbar-brand" href="/">Library Management</a>
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav ms-auto">
        <li className="nav-item">
                <a className="nav-link" href="/success">
                   Books
                </a>
              </li>
          <li className="nav-item">
            <a className="nav-link" href="/userhome">Home</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/profile">Profile</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/rentalhistory">Rented Books</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/purchasehistory">Purchase History</a>
          </li>
          <li className="nav-item">
            <a href="/login" className="btn btn-danger">Logout</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <div className="rent-book-page container  pt-5">
    
    <h2>{book.title}</h2>
    <p><strong>Author:</strong> {book.author}</p>
    <p><strong>Publisher:</strong> {book.publisher}</p>
    <p><strong>Price (per copy):</strong> ${book.price}</p>
    {/* <p><strong>Logged-in User:</strong> {userName}</p> */}

    <div className="mb-3 mt-5">
  <label className="form-label">Quantity (Max: {book.stock}):</label>
  <div className="d-flex align-items-center">
    <button
      className="btn btn-outline-primary flex-equal"
      onClick={() => setQuantity((prev) => Math.max(1, prev - 1))}
    >
      -
    </button>
    <input
      type="number"
      className="form-control text-center flex-equal"
      value={quantity}
      min="1"
      max={book.stock}
      onChange={(e) => setQuantity(e.target.value)}
    />
    <button
      className="btn btn-outline-primary flex-equal"
      onClick={() => setQuantity((prev) => Math.min(book.stock, prev + 1))}
    >
      +
    </button>
  </div>
</div>


    <div className="mb-3">
      <label>Phone Number:</label>
      <input
        type="text"
        className="form-control"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        placeholder="Enter your phone number"
      />
    </div>

    <div className="mb-3">
      <label>Rent Date:</label>
      <input
        type="date"
        className="form-control"
        value={rentDate}
        onChange={(e) => setRentDate(e.target.value)}
      />
    </div>

    <div className="mb-3">
  <label>Rental Period (Days):</label>
  <div className="d-flex align-items-center">
    <button className="btn btn-outline-primary flex-equal" onClick={handleDecrement}>
      -
    </button>
    <input
      type="number"
      className="form-control text-center flex-equal"
      value={rentDays}
      min="1"
      onChange={(e) => setRentDays(e.target.value)}
    />
    <button className="btn btn-outline-primary flex-equal" onClick={handleIncrement}>
      +
    </button>
  </div>
</div>

    <div className="mb-3">
      <label>Return Date:</label>
      <input type="date" className="form-control" value={returnDate} readOnly />
    </div>

    <div className="mb-3">
      <label>Status:</label>
      <input type="text" className="form-control" value={status} readOnly />
    </div>

    <div className="mb-3">
      <label>Fine:</label>
      <input type="text" className="form-control" value={fine.toFixed(2)} readOnly />
    </div>

    <div className="mb-3">
      <label>Total Price:</label>
      <input
        type="text"
        className="form-control"
        value={(book.price * 0.02 * rentDays).toFixed(2)}
        readOnly
      />
    </div>

    <button className="btn btn-primary" onClick={handleRent}>Rent</button>
  </div>
</div>

  );
}

export default RentBookPage;
